<p-card header="Сертификат НМО {{ data.dateCertificatePrint }}">
  <div class="grid">
    <div class="col-12 md:col-6" *ngIf="data.presentMarksLength > 0">
      <p class="font-bold">Отметки</p>
      <ul *ngFor="let mark of data.presentMarks">
        <li>{{mark}}</li>
      </ul>
    </div>
    <div class="col-12 md:col-6" *ngIf="data.certificateCode">
      <p class="font-bold">Код НМО</p>
      <div>
        <i class="pi pi-copy mr-2" style="cursor: pointer;" ngxClipboard [cbContent]="data.certificateCode"></i>
        {{ data.certificateCode }}
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Поставить отметку" *ngIf="data.isArrive && !isReadOnly" styleClass="mr-2"
      (click)="onSetMark()"></p-button>
    <p-button *ngIf="data.certificateCode === '' && !isReadOnly" label="Получить Код" styleClass="mr-2"
      (click)="onCert(true)">
    </p-button>
    <p-button *ngIf="data.certificateCode !== '' && !isReadOnly" label="Удалить Код" styleClass="p-button-danger mr-2"
      (click)="onCert(false)"></p-button>
    <p-button *ngIf="data.certificateCode !== ''" label="Печать сертификата" styleClass="p-button-success mr-2"
      (click)="onPrint()"></p-button>
    <p-button *ngIf="data.certificateCode !== ''" label="Отправить сертификат" styleClass="p-button-success mr-2"
      (click)="onSend()"></p-button>
  </ng-template>
</p-card>
